import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// Soft UI Context Provider
import { MaterialUIControllerProvider } from 'context';

// Constants
import { config } from 'Constants';
import { SearchProvider } from 'layouts/projects/Pages/SearchProvider';

const queryClient = new QueryClient();

ReactDOM.render(
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <MaterialUIControllerProvider>
                <SearchProvider>
                    <App />
                    <Toaster />
                </SearchProvider>
            </MaterialUIControllerProvider>
            <ReactQueryDevtools initialIsOpen={config.url.API_URL.includes('localhost')} />
        </QueryClientProvider>
    </BrowserRouter>,
    document.getElementById('root')
);
